"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MFERenderedPages = void 0;
var MFERenderedPages;
(function (MFERenderedPages) {
    MFERenderedPages["OUTREACH"] = "OUTREACH";
    MFERenderedPages["CUSTOMER_SEARCH"] = "CUSTOMER_SEARCH";
})(MFERenderedPages || (exports.MFERenderedPages = MFERenderedPages = {}));
//# sourceMappingURL=index.js.map